import PropTypes from 'prop-types';
import { Box, OutlinedInput } from '@mui/material';

import { SearchIcon } from 'assets/icons';

const styles = {
  icon: ({ palette }) => ({
    width: 32,
    height: 32,
    color: palette.colors.darkGrey,
  }),
  input: ({ palette, breakpoints }) => ({
    borderRadius: '60px',
    gap: 1,
    width: '100%',

    [breakpoints.up('sm')]: {
      width: 500,
    },

    '.MuiInputBase-input': {
      height: 47,
      paddingBlock: 0,
      paddingLeft: 5,

      '&::placeholder': {
        color: palette.colors.lightGrey,
        opacity: 1,
      },
    },

    '.MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${palette.colors.lightGrey} !important`,
    },
  }),
};

const SearchInput = ({ searchValue, setSearchValue, customStyles = {} }) => (
  <OutlinedInput
    placeholder="Search"
    endAdornment={<Box component={SearchIcon} sx={styles.icon} />}
    value={searchValue}
    onChange={({ target: { value } }) => setSearchValue(value.trimStart())}
    sx={[styles.input, customStyles]}
  />
);

SearchInput.propTypes = {
  searchValue: PropTypes.string.isRequired,
  setSearchValue: PropTypes.func.isRequired,
  customStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};
export default SearchInput;
